import { TProductConfigResponse } from '../../../types/product.configuration.types';
import NudosConfigurationStatus from './NudosConfigurationStatus/NudosConfigurationStatus';

import './NudosToolConfigurations.scss';

const NudosToolConfigurations = ({
  styling,
  configurationsData
}: {
  styling: 'toolDetails' | 'logisticServiceDetails' | 'toolHistoryCardConfigurations';
  configurationsData?: TProductConfigResponse[];
}) => {
  if (!configurationsData?.length) return <></>;
  const isAppleConfiguration = configurationsData.some(item => (item.data?.length ?? 0) > 0);
  return (
    <div className={`nudosToolConfigurations ${styling}`}>
      {configurationsData.map(configuration => {
        return (
          <NudosConfigurationStatus
            key={`${configuration.configClassName}-${configuration.id}`}
            configurationData={configuration}
            isAdditionalSettingsInOrders={isAppleConfiguration}
          />
        );
      })}
    </div>
  );
};

export default NudosToolConfigurations;
